import React from 'react'
import PropTypes from 'prop-types'

const ContentHeader = ({ children, className }) => (
  <div className={`content-header ${className || ''}`}>
    <span className='header-title'>{children}</span>
  </div>
)

ContentHeader.propTypes = {
  children: PropTypes.string.isRequired,
  className: PropTypes.object,
}

export default ContentHeader
